import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Youtube, Heart } from 'lucide-react';
import { FOLLOW_LINKS } from '../mock';
import { useLang } from '../context/LanguageContext';

const iconFor = (name) => {
  if (name === 'Facebook') return Facebook;
  if (name === 'Instagram') return Instagram;
  if (name === 'Twitter') return Twitter;
  if (name === 'YouTube') return Youtube;
  return Facebook;
};

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative bg-[#f5b400] text-black">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex flex-col items-center md:items-start gap-3">
          <Link
            to="/terms"
            className="px-6 py-2 rounded-full bg-black text-white font-nav text-xs hover:bg-neutral-800 transition-colors"
          >
            {t('footer.terms')}
          </Link>
          <Link
            to="/donate"
            className="px-6 py-2 rounded-full bg-black text-white font-nav text-xs hover:bg-neutral-800 transition-colors inline-flex items-center gap-2"
          >
            <Heart size={14} className="text-[#f5b400]" fill="currentColor" />
            {t('footer.support')}
          </Link>
        </div>

        <div className="text-center">
          <p className="font-heading text-sm md:text-base tracking-wider">
            {t('footer.copyright')}
          </p>
        </div>

        <div className="flex flex-col items-center md:items-end gap-3">
          <div className="flex gap-3">
            {FOLLOW_LINKS.map((l) => {
              const Icon = iconFor(l.name);
              return (
                <a
                  key={l.name}
                  href={l.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={l.name}
                  className="w-10 h-10 rounded-md bg-black text-[#f5b400] flex items-center justify-center hover:bg-neutral-900 hover:scale-110 transition-all"
                >
                  <Icon size={18} />
                </a>
              );
            })}
          </div>
          <p className="font-nav text-xs uppercase">{t('footer.follow_us')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
